(function ($, window) {
    $(document).ready(init);

    /**
     * Handle menu
     */
    function init() {
        var $menuOpen = $('.header__button--open-menu');
        var $menuClose = $('.menu__button--close');
        var $menu = $('.menu');
        var $headerButtons = $('.header__buttons');

        $menuOpen.click(openMenu);
        $menuClose.click(closeMenu);

        function closeMenu () {
            $headerButtons.removeClass('header__buttons--hidden');
            $menu.addClass('menu--hidden');
        }

        function openMenu() {
            $headerButtons.addClass('header__buttons--hidden');
            $menu.removeClass('menu--hidden');
        }

        $(document).mouseup(function (e) {
            if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && !$menuOpen.is(e.target)) {
                closeMenu();
            }
        });

        //Unfold the menu
        $('.menu__html li').on('click', function (e) {
            var $target = $(e.target);

            // open menu if there are any sub-menu items
            if ($target.find('> ul').length > 0) {
                e.preventDefault();

                // get menu item
                // var $menu_element = $target;

                // close other menu items
                $target.siblings().removeClass('active');
                $target.toggleClass('active');
            }
        });
    }


})(jQuery, window);